module.exports = __webpack_public_path__ + "static/media/m11tj93.90b7970b.png";